import React, { useState, useEffect } from "react";
import { Dropdown } from "antd";

import { getScenarios } from "../../../services/api";

export default function Index({ label }) {
  const [data, setData] = useState([]);
  useEffect(() => {
    ScenarioList();
  }, []);

  const ScenarioList = async () => {
    const res = await getScenarios();
    if (res.status === 200) {
      setData(res.data);
    }
  };
  const overlay = (
    <div className="bg-white px-6 py-6 max-w-sm rounded-lg shadow-md">
      {data.map(
        (item) =>
          item.scenario_name === label && (
            <div>
              <h1 className="font-bold text-lg">{item.scenario_name}</h1>
              <p>
                {item.description ? (
                  item.description
                ) : (
                  <span className="text-gray-300">No description...</span>
                )}
              </p>
            </div>
          )
      )}
    </div>
  );

  return (
    <div>
      <Dropdown overlay={overlay} placement="bottomCenter">
        <a className="text-black font-medium">{label}</a>
      </Dropdown>
    </div>
  );
}
